import React, { useState, useEffect, useRef } from "react";
import "./OneTeam.css";

import kitchenImg from "../../assets/kitchen.png";
import wardrobeImg from "../../assets/wardrobe.png";  
import bedImg from "../../assets/bed.png";
import sofaImg from "../../assets/orbit-img/sofa.png"; 
import furnitureImg from "../../assets/furniture.png";

// import paths if your actual files are named differently.
import carpentryImg from "../../assets/orbit-img/carpantry.png";
import civilImg from "../../assets/orbit-img/civil.png";
import electricalImg from "../../assets/orbit-img/Installation.png";
import paintingImg from "../../assets/orbit-img/Painting.png";
import lightingImg from "../../assets/orbit-img/Lighting.png";
import installationImg from "../../assets/interior-design.png";

const ORBIT_NODES = [
  { id: "furniture", label: "Loose Furniture", img: furnitureImg, alt: "Chairs, tables & accents", style: { left: "84%", top: "70%" } },
  { id: "beds", label: "Beds", img: bedImg, alt: "Premium beds", style: { left: "50%", top: "4%" } },
  { id: "wardrobes", label: "Wardrobes", img: wardrobeImg, alt: "Glass wardrobes", style: { left: "86%", top: "30%" } },
  { id: "sofas", label: "Sofas", img: sofaImg, alt: "Sofas", style: { left: "16%", top: "70%" } },
  { id: "kitchen", label: "Kitchen", img: kitchenImg, alt: "Modular kitchen", style: { left: "14%", top: "30%" } },
];

// six-point layout for the on-site orbit (hexagon around the hub)
const ONSITE_ORBIT_NODES = [
  { id: "installation", label: "Interior Design", img: installationImg, alt: "Interior design services", style:  { left: "50%", top: "4%" }  },
  // { id: "electrical", label: "Electrical", img: electricalImg, alt: "Electrical work", style: { 
  //  left: "17%", top: "65%" } },
    { id: "electrical", label: "Installation", img: electricalImg, alt: "Electrical work", style: { 
   left: "17%", top: "65%" } },
  { id: "painting", label: "Painting", img: paintingImg, alt: "Painting work", style: { left: "83%", top: "65%" } },
  { id: "civil", label: "Civil", img: civilImg, alt: "Civil work", style: { left: "50%", top: "85%" } },
  { id: "lighting", label: "Lighting/Electrical", img: lightingImg, alt: "Lighting work", style: {
      left: "89%", top: "29%" } },
  { id: "carpentry", label: "Carpentry", img: carpentryImg, alt: "Carpentry work", style:
     { left: "10%", top: "29%" } },
];

const STEPS = [
  { step: "01", title: "One brief", body: "You share the home, budget and timeline once. No repeating it to every vendor." },
  { step: "02", title: "We assemble the team", body: "Dwellora picks the right specialist for each scope and locks the sequence." },
  { step: "03", title: "We run the site", body: "Scheduling, coordination and quality checks happen without you following up." },
  { step: "04", title: "One handover", body: "Snag-free completion with a single warranty conversation — with us." },
];

// simple line icons, drawn to sit inside a small circle — no external assets needed
function OnsiteIcon({ name }) {
  const common = { width: 18, height: 18, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.7, strokeLinecap: "round", strokeLinejoin: "round" };
  switch (name) {
    case "carpentry":
      return (
        <svg {...common}><path d="M3 21l7-7" /><path d="M13.5 4.5l6 6-2.5 2.5-6-6z" /><path d="M9 15l-2 2 2 2 2-2" /><path d="M15.5 6.5l2-2" /></svg>
      );
    case "civil":
      return (
        <svg {...common}><path d="M3 21h18" /><path d="M5 21V9l7-5 7 5v12" /><path d="M9 21v-6h6v6" /></svg>
      );
    case "electrical":
      return <svg {...common}><path d="M12 2 4 14h6l-1 8 9-13h-6z" /></svg>;
    case "painting":
      return (
        <svg {...common}><path d="M4 21c0-3 1.5-4.5 3-4.5S10 18 10 21" /><path d="M7 16.5V9l9-5 3 3-5 9H7z" /></svg>
      );
    case "lighting":
      return (
        <svg {...common}><path d="M9 18h6" /><path d="M10 21h4" /><path d="M12 3a6 6 0 0 0-4 10.5c.7.6 1 1.4 1 2.5h6c0-1.1.3-1.9 1-2.5A6 6 0 0 0 12 3z" /></svg>
      );
    case "installation":
      // return (
      //   <svg {...common}><path d="M14.7 6.3a3 3 0 1 0-4.2 4.2L3 18v3h3l7.5-7.5a3 3 0 1 0 4.2-4.2z" /></svg>
      // );
      return (
    <svg {...common}>
      <path d="M4 20V9l8-6 8 6v11" />
      <path d="M7 20v-6h10v6" />
      <path d="M9 14h6" />
      <path d="M17 5l2-2 2 2-2 2z" />
      <path d="M16 6l-2 4 4-1" />
    </svg>
  );
    default:
      return null;
  }
}

// icons for the specialist-products list, same visual language as OnsiteIcon
function SpecialistIcon({ name }) {
  const common = { width: 18, height: 18, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.7, strokeLinecap: "round", strokeLinejoin: "round" };
  switch (name) {
    case "kitchen":
      return <svg {...common}><path d="M4 8h16" /><path d="M4 8v11a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V8" /><path d="M9 3v5" /><path d="M15 3v5" /><path d="M9 14h6" /></svg>;
    case "wardrobes":
      return <svg {...common}><rect x="4" y="3" width="16" height="18" rx="1" /><path d="M12 3v18" /><path d="M8 12v.01" /><path d="M16 12v.01" /></svg>;
    case "beds":
      return <svg {...common}><path d="M3 18v-5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v5" /><path d="M3 18v2" /><path d="M21 18v2" /><path d="M3 13V8a1 1 0 0 1 1-1h6v6" /></svg>;
    case "sofas":
      return <svg {...common}><path d="M4 11V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3" /><path d="M3 12h18v4a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z" /><path d="M4 17v3" /><path d="M20 17v3" /></svg>;
    case "seating":
      return <svg {...common}><path d="M6 20V10a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v10" /><path d="M6 15h12" /><path d="M6 20h1" /><path d="M17 20h1" /></svg>;
    case "furniture":
      return <svg {...common}><circle cx="12" cy="7" r="2.5" /><path d="M5 21v-6a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v6" /><path d="M9 21v-3" /><path d="M15 21v-3" /></svg>;
    default:
      return null;
  }
}

const ONSITE_ITEMS = [
  { id: "carpentry", label: "Carpentry" },
  { id: "civil", label: "Civil" },
  // { id: "electrical", label: "Electrical" },
  { id: "electrical", label: "Installation" },
  { id: "painting", label: "Painting" },
  { id: "lighting", label: "Lighting/Electrical" },
  { id: "installation", label: "Interior Design" },
];

// same image assets already used in the orbit — reused here for the hover preview
const SPECIALIST_ITEMS = [
  { id: "kitchen", label: "Modular Kitchen", img: kitchenImg },
  { id: "wardrobes", label: "Glass Wardrobes", img: wardrobeImg },
  { id: "beds", label: "Premium Beds", img: bedImg },
  { id: "sofas", label: "Sofas", img: sofaImg },
  { id: "seating", label: "Accent Seating", img: furnitureImg },
  { id: "furniture", label: "Loose Furniture", img: furnitureImg },
];

// one orbit (glow/rings/hub/nodes) — used for the single toggling desktop
// orbit AND for each of the two fixed orbits shown on mobile.
// hubTitle/hubSubtitle let each orbit show its own center text:
// On-site execution keeps "Managed by Dwellora" / "Project-led services",
// Specialist products shows "Specialist partners" / "Selected expert network".
// variant ("onsite" | "specialist") is only used on mobile: it adds a
// modifier class so the on-site (6-node hex) and specialist (5-node
// pentagon) orbits can each get their own rotation timing/spacing in CSS
// instead of sharing one animation built for 6 stops.
function Orbit({
  nodes,
  keyLabel,
  dotClass,
  keyPrefix,
  hubTitle = "Managed by Dwellora",
  hubSubtitle = "Project-led services",
  variant,
}) {
  const nodesClass = `ot-orbit-nodes${variant ? ` ot-orbit-nodes--${variant}` : ""}`;
  const nodeClass = `ot-node${variant ? ` ot-node--${variant}` : ""}`;

  return (
    <>
      <div className="ot-orbit">
        <div className="ot-orbit-glow" />
        <div className="ot-ring" />
        <div className="ot-ring ot-ring--inner" />

        <div className="ot-hub">
          <div>
             <strong>{hubTitle}</strong>
            <span style={{fontSize:10}} >{hubSubtitle}</span>
          </div>
        </div>

        {/* {nodes.map((node, i) => (
          <div
            key={`${keyPrefix}-${node.id}`}
            className="ot-node"
            style={{ ...node.style, "--ot-delay": `${i * 0.09}s` }}
          >
            <div className="ot-node-circle">
              <img src={node.img} alt={node.alt} />
            </div>
            <b>{node.label}</b>
          </div>
        ))} */}

        <div className={nodesClass}>
          {nodes.map((node, i) => (
            <div
              key={`${keyPrefix}-${node.id}`}
              className={nodeClass}  
              data-node={node.id}
              style={{ ...node.style, "--ot-delay": `${i * 0.09}s` }}
            >
              <div className="ot-node-circle">
                <img src={node.img} alt={node.alt} />
              </div>
              <b>{node.label}</b>
            </div>
          ))}
        </div>

      </div>

      <div className="ot-orbit-key">
        <span>
          <i className={dotClass} /> {keyLabel}
        </span>
      </div>
    </>
  );
}

export default function OneTeam() {
  const [activeOnsite, setActiveOnsite] = useState(null);
  const [activeSpecialist, setActiveSpecialist] = useState(null);

  // controls which set of nodes shows in the single desktop orbit.
  // Autoplay drives this: it alternates between "onsite" and "specialist"
  // every 5 seconds, and whichever one is active gets the highlighted
  // (colored + zoomed) card while the other sits back as a plain gray card.
  // Mobile ignores this — it renders both orbits fixed, side by side, always visible.
  const [activeOrbit, setActiveOrbit] = useState("onsite");

  // hovering a desktop track pauses autoplay on that card's orbit; the
  // interval keeps running in the background and simply resumes ticking
  // once the pointer leaves — a ref (not state) so the interval callback
  // always reads the latest value without needing to be recreated.
  const isPausedRef = useRef(false);

  // autoplay: flip the active card/orbit every 5s (desktop only — mobile
  // shows both orbits at once already, so this has no visible effect there)
  useEffect(() => {
    const id = setInterval(() => {
      if (isPausedRef.current) return;
      setActiveOrbit((prev) => (prev === "onsite" ? "specialist" : "onsite"));
    }, 5000);
    return () => clearInterval(id);
  }, []);

  const handleTrackEnter = (orbit) => {
    isPausedRef.current = true;
    setActiveOrbit(orbit);
  };

  const handleTrackLeave = () => {
    isPausedRef.current = false;
  };

  const toggleOnsite = (id) => setActiveOnsite((prev) => (prev === id ? null : id));
  const toggleSpecialist = (id) => setActiveSpecialist((prev) => (prev === id ? null : id));

  const orbitNodes = activeOrbit === "onsite" ? ONSITE_ORBIT_NODES : ORBIT_NODES;
  const orbitKeyLabel = activeOrbit === "onsite" ? "On-site execution team" : "Specialist partner products";
  const orbitDotClass = activeOrbit === "onsite" ? "ot-dot ot-dot--b" : "ot-dot ot-dot--a";
  const orbitHubTitle = activeOrbit === "onsite" ? "Executed by Dwellora" : "Specialist partners";
  const orbitHubSubtitle = activeOrbit === "onsite" ? "Done by Dwellora’s own team" : "Selected expert network";

  // specialist-products card body — reused for the desktop track and the mobile track
  const SpecialistTrackBody = ({ idPrefix }) => (
    <>
      <span className="ot-kicker">Specialist products</span>
      <h3 className="ot-h3">Made by specialists. Managed by Dwellora.</h3>
      <p>
       For products where specialized manufacturing delivers better results, we collaborate with carefully selected industry partners. Dwellora manages the design, specifications, selection, pricing, coordination and installation.
      </p>

      <ul className="ot-onsite-grid">
        {SPECIALIST_ITEMS.map((item) => (
          <li
            key={`${idPrefix}-${item.id}`}
            className={activeSpecialist === item.id ? "is-active" : ""}
            onClick={(e) => {
              e.stopPropagation();
              toggleSpecialist(item.id);
            }}
            role="button"
            tabIndex={0}
            aria-pressed={activeSpecialist === item.id}
            onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && toggleSpecialist(item.id)}
          >
            <span className="ot-onsite-icon ot-onsite-icon--accent">
              <SpecialistIcon name={item.id} />
            </span>
            <span className="ot-onsite-label">{item.label}</span>
          </li>
        ))}
      </ul>
    </>
  );

  // on-site card body — reused for the desktop track and the mobile track
  const OnsiteTrackBody = ({ idPrefix }) => (
    <>
      <span className="ot-kicker ot-kicker--sage">On-site execution</span>
      <h3 className="ot-h3">Executed by Dwellora's own team</h3>
      <p>
       The work that brings your design to life is managed and executed by our own team — giving us direct control over craftsmanship, coordination, quality and timelines from site to handover.
      </p>

      <ul className="ot-onsite-grid">
        {ONSITE_ITEMS.map((item) => (
          <li
            key={`${idPrefix}-${item.id}`}
            className={activeOnsite === item.id ? "is-active" : ""}
            onClick={() => toggleOnsite(item.id)}
            role="button"
            tabIndex={0}
            aria-pressed={activeOnsite === item.id}
            onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && toggleOnsite(item.id)}
          >
            <span className="ot-onsite-icon">
              <OnsiteIcon name={item.id} />
            </span>
            <span className="ot-onsite-label">{item.label}</span>
          </li>
        ))}
      </ul>
    </>
  );



  return (
    <section className="ot-section">
      <div className="ot-wrap">
        <span className="ot-kicker">The Dwellora Model</span>
        <h2 className="ot-h2">
          The right expertise for every detail.
        </h2>
        <p className="ot-lede">
         Expert design, specialist craftsmanship and controlled execution — working together to create better interiors.
        </p>

        <div className="ot-chain" aria-label="Coordination flow">
          <span className="ot-pill">You</span>

  <span className="ot-arrow">&rarr;</span>
          <span className="ot-pill">On-site team + specialist partners</span>

          <span className="ot-arrow">&rarr;</span>
          <span className="ot-pill ot-pill--solid">Dwellora — single point of contact</span>
        
        </div>

        <div className="ot-split">
          {/* ===== Desktop: one orbit that swaps on hover/click (unchanged) ===== */}
          <div className="ot-desktop-only">
            <Orbit
              nodes={orbitNodes}
              keyLabel={orbitKeyLabel}
              dotClass={orbitDotClass}
              keyPrefix="d"
              hubTitle={orbitHubTitle}
              hubSubtitle={orbitHubSubtitle}
            />
          </div>

          <div className="ot-desktop-only">

            <div
              className={`ot-track ${
                activeOrbit === "onsite" ? "ot-track--zoomed" : "ot-track--inactive"
              }`}
              onMouseEnter={() => handleTrackEnter("onsite")}
              onMouseLeave={handleTrackLeave}
            >
              <OnsiteTrackBody idPrefix="d" />
            </div>

            <div
              className={`ot-track ot-track--accent ${
                activeOrbit === "specialist" ? "ot-track--zoomed" : "ot-track--inactive"
              }`}
              onMouseEnter={() => handleTrackEnter("specialist")}
              onMouseLeave={handleTrackLeave}
            >
              <SpecialistTrackBody idPrefix="d" />
            </div>

          
          </div>

          {/* ===== Mobile: both orbits always visible, each followed by its own card ===== */}
          <div className="ot-mobile-only ot-mobile-pair">
            <Orbit
              nodes={ONSITE_ORBIT_NODES}
              keyLabel="On-site execution team"
              dotClass="ot-dot ot-dot--b"
              keyPrefix="m-onsite"
              hubTitle="Managed by Dwellora"
              hubSubtitle="Project-led services"
              variant="onsite"
            />
            <div className="ot-track">
              <OnsiteTrackBody idPrefix="m" />
            </div>
          </div>

          <div className="ot-mobile-only ot-mobile-pair">
            <Orbit
              nodes={ORBIT_NODES}
              keyLabel="Specialist partner products"
              dotClass="ot-dot ot-dot--a"
              keyPrefix="m-specialist"
              hubTitle="Specialist partners"
              hubSubtitle="Selected expert network"
              variant="specialist"
            />
            <div className="ot-track ot-track--accent">
              <SpecialistTrackBody idPrefix="m" />
            </div>
          </div>
        </div>

        {/* <div className="ot-steps">
          {STEPS.map((s, i) => (
            <div className="ot-step" key={s.step}>
              <span className="ot-step-num">{s.step}</span>
              <h3 className="ot-h3">{s.title}</h3>
              <p>{s.body}</p>
              {i < STEPS.length - 1 && <span className="ot-step-line" aria-hidden="true" />}
            </div>
          ))}
        </div> */}
      </div>
    </section>
  );
}